<template>
    <div class="">
       <div style="margin-top: 20px;">
        <el-form
            ref="editModalForm"
            label-width="200px"
          >
            <el-form-item label="迪信物流余额">
                <div style="float: left;margin-right: 20px;width: 120px;">{{ expressBalance }} 元</div>
                <el-button @click="getExpressBalance">刷新</el-button>
            </el-form-item>
            <el-form-item label="物流充值金额" >
                <el-input 
                clearable
                v-model="expressRechargePrice"
                style="width: 120px;"
              ></el-input>
                <el-button style="margin-left: 20px;" @click="getExpressRechargePrice">去充值</el-button>
            </el-form-item>
            <el-form-item label="迪信通资金余额">
                <div style="float: left;margin-right: 20px;width: 120px;">{{ balance }} 元</div>
                <el-button @click="getRecycleFund">刷新</el-button>
            </el-form-item>
            <el-form-item label="充值金额" >
                <el-input 
                clearable
                v-model="rechargePrice"
                style="width: 120px;"
              ></el-input>
                <el-button style="margin-left: 20px;" @click="getRechargePrice">去充值</el-button>
            </el-form-item>
            <el-form-item label="充值二维码" prop="name" v-if="rechargeUrl!=null">
                <canvas ref="qrCanvas" width="250" height="250" style="scale: 0.5;"></canvas>
            </el-form-item>
          </el-form>
       </div>
  
    </div>
  </template>
  
  <script>
  import QRCode from 'qrcode'
  export default {
    components:{},
    props:{},
    data(){
      return {
        balance:0,
        rechargePrice:null,
        rechargeUrl: null,
        expressBalance:0,
        expressRechargePrice:null,
      }
    },
    watch:{},
    computed:{},
    methods:{
    generateQRCode(val) {
      QRCode.toCanvas(this.$refs.qrCanvas, val, error => {
        if (error) console.error(error)
      })
    },
        // 分页函数
    getRecycleFund() {
        let self = this
        self.$api.getRecycleFund({}).then(e=>{
            if(e.code==200){
                self.balance = e.data.recycleBalance
            }else{
                self.$message({
                message: "查询迪信通资产失败",
                type: "warn",
            });
            }
        })
      },
    getExpressBalance(){
      let self = this
        self.$api.getExpressBalance({}).then(e=>{
            if(e.code==200){
                self.expressBalance = e.data.amount
            }else{
                self.$message({
                message: "查询迪信通物流资产失败",
                type: "warn",
            });
            }
        })
    },
    getExpressRechargePrice() {
        let self = this
        self.$api.getExpressRechargePrice({amount:self.expressRechargePrice}).then(res=>{
            if(res.code===200){
              self.$message({
                  message: "物流充值成功",
                  type: "info",
              });
            }
        })
        
      },
    getRechargePrice() {
        let self = this
        self.$api.getRechargePrice({price:self.rechargePrice}).then(res=>{
            if(res.data!=null){
                self.rechargeUrl = res.data.url
                self.$nextTick(()=>{
                    self.generateQRCode(self.rechargeUrl)
                })
            }else{
                self.$message({
                message: "生成充值链接失败",
                type: "warn",
            });
            }
        })
        
      },
    },
    created(){
        let self = this;
        self.getRecycleFund()
        self.getExpressBalance()
    },
    mounted(){
    }
  }
  </script>